import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showGCSettingsModal } from '../../../../actions/modal';
import { updateGCSettingCall } from '../../../../actions/waitingArea';

const RightPanelUpdate = ({ waitingArea, setSaveButtonDisableClass, saveButtonDisableClass, validateForm }) => {
  const dispatch = useDispatch();
  const [isUpdating, setIsUpdating] = useState(false);
  const gcWaitingAreaSettings = useSelector((state) => state.waitingAreaReducer.gcWaitingAreaSettings);
  const gcWaitngAreaSettingForm = useSelector((state) => state.waitingAreaReducer.gcWaitngAreaSettingForm);

  const updateGCSettings = () => {
    setSaveButtonDisableClass('');
    setIsUpdating(true);
    let cb = () => {
      setIsUpdating(false);
      dispatch(showGCSettingsModal(false));
    };
    dispatch(updateGCSettingCall(waitingArea.id, gcWaitngAreaSettingForm, cb));
  };

  useEffect(() => {
    if (JSON.stringify(validateForm) !== JSON.stringify(gcWaitngAreaSettingForm)) {
      setSaveButtonDisableClass('');
    } else {
      setSaveButtonDisableClass('disable');
    }
  }, [gcWaitngAreaSettingForm]);

  const saveModalChange = (event) => {
    if (JSON.stringify(validateForm) !== JSON.stringify(gcWaitngAreaSettingForm)) {
      updateGCSettings();
    }
  };

  const closeModal = () => {
    dispatch(showGCSettingsModal(false));
  };

  let saveClasses =
    'ui  labeled icon button icon left-text color-button color-button-hover color-white max-width  mrlnull mrbnull';
  return (
    <div>
      {gcWaitingAreaSettings?.isChatEditable || gcWaitingAreaSettings?.isCallerFullNameEditable ? (
        <div className="mrtxxs mrbl max-width">
          <button
            tabIndex="4"
            type="button"
            onClick={saveModalChange}
            data-group="GCSettings"
            className={isUpdating ? saveClasses + ' loading' : `${saveClasses} ${saveButtonDisableClass}`}
          >
            {APP.LANGUAGE.Save}
            <i className="checkmark icon" />
          </button>
          <button
            tabIndex="5"
            type="button"
            onClick={closeModal}
            className="ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrtm mrlnull mrbnull"
          >
            <i className="remove  icon" />
            {APP.LANGUAGE.Cancel}
          </button>
        </div>
      ) : (
        <div className="mrbl max-width mrtxxs ">
          <button
            onClick={closeModal}
            className="ui cancel  labeled icon button color-bad-things color-bad-things-hover color-white   max-width left-text mrlnull mrbnull"
          >
            <i className="remove  icon" />
            {APP.LANGUAGE.Close}
          </button>
        </div>
      )}
    </div>
  );
};

export default RightPanelUpdate;
